query allCompetitionsById($ids: [UUID!]) {
  competitions: allCompetitions(
    first: 100
    filter: { competitionId: { in: $ids } }
  ) {
    nodes {
      competitionId
      competitionName
    }
  }
}
